export interface FeedbackTrigger {
  /** Must match an AnalyticsEvents value */
  event: string
  delaySec: number
  surveyKey: string
  cooldownDays: number
  /** Only fire if the user meets a minimum session/study count (optional) */
  minSessionCount?: number
}

export const FEEDBACK_TRIGGERS: FeedbackTrigger[] = [
  {
    // Fires only on the creator's first-ever open — see AudienceDetailContent tracking useEffect.
    event: 'audience_first_creator_view',
    delaySec: 15,
    surveyKey: 'audience_experience',
    cooldownDays: 1,
  },
  {
    event: 'results_page_viewed',
    delaySec: 15,
    surveyKey: 'study_experience',
    cooldownDays: 1,
  },
  {
    event: 'experiment_twin_chat_message_sent',
    delaySec: 15,
    surveyKey: 'chat_experience',
    cooldownDays: 1,
  },
]

// ---------------------------------------------------------------------------
// Cooldown helpers (localStorage)
// ---------------------------------------------------------------------------

export function isGlobalCooldownActive(): boolean {
  return false
}

export function setGlobalCooldown(): void {
  // global cooldown removed — each trigger has its own 24 h cooldown
}

export function triggerCooldownStorageKey(event: string): string {
  return `feedback_trigger_${event}_last`
}

export function isTriggerCoolingDown(event: string, cooldownDays: number): boolean {
  try {
    const raw = localStorage.getItem(triggerCooldownStorageKey(event))
    if (!raw) return false
    return Date.now() - Number(raw) < cooldownDays * 24 * 60 * 60 * 1000
  } catch {
    return false
  }
}

export function setTriggerCooldown(event: string): void {
  try {
    localStorage.setItem(triggerCooldownStorageKey(event), String(Date.now()))
  } catch { /* noop */ }
}
